import {
    faFacebookSquare,
    faGithubSquare,
    faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelopeSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import emailjs from "emailjs-com";
import React from "react";
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import Header from "../Home/Header/Header";
import "./Contact.css";

const Contact = () => {
    function sendEmail(e) {
        e.preventDefault();

        emailjs
            .sendForm(
                "gmail",
                "template_ho7rh16",
                e.target,
                "user_gQh6jYhGzarnDQ279CXAd"
            )
            .then(
                (result) => {
                    console.log(result.text);
                    if (result) {
                        alert(
                            "Thank you for your message. I will contact with you as soon as possible. Have a Good day !"
                        );
                    }
                },
                (error) => {
                    console.log(error.text);
                }
            );
        e.target.reset();
    }

    return (
        <div className="container">
            <Header></Header>
            <div className="mt-3">
                <div className="form-container">
                    <h3 className="text-center mb-3">Contact With Me</h3>
                    <form className="contact-form" onSubmit={sendEmail}>
                        <input
                            className="form-control"
                            type="text"
                            name="name"
                            placeholder="Your name"
                            required
                        />
                        <br />
                        <input
                            className="form-control"
                            type="email"
                            name="email"
                            placeholder="Your email"
                            required
                        />
                        <br />
                        <textarea
                            className="form-control"
                            name="message"
                            rows="4"
                            cols="50"
                            placeholder="Message....."
                            required
                        />
                        <br />
                        <input
                            type="submit"
                            className="form-control button"
                            value="Send"
                        />
                    </form>
                    <p className="mt-3">
                        <i>
                            Sending to{" "}
                            <a
                                className="my-mail"
                                href="mailto:josesaurav@gmail.com"
                            >
                                josesaurav@gmail.com
                            </a>
                        </i>
                    </p>
                </div>
            </div>
            <div className="contact-icon">
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.linkedin.com/in/saurav-ghosh-6a1ab0202/"
                >
                    <FontAwesomeIcon className="icon" icon={faLinkedin} />
                </a>
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://github.com/saurav-ghosh"
                >
                    <FontAwesomeIcon className="icon" icon={faGithubSquare} />
                </a>
                <Link to="/contact">
                    <FontAwesomeIcon className="icon" icon={faEnvelopeSquare} />
                </Link>
                <FontAwesomeIcon className="icon" icon={faFacebookSquare} />
            </div>
            <Footer></Footer>
        </div>
    );
};

export default Contact;
